import { motion } from "framer-motion";
import { useI18n } from "@/i18n";
import { EASE, Reveal, SectionHead } from "./Reveal";

export const Approach = () => {
  const { t } = useI18n();
  return (
    <section id="approach" data-testid="approach-section" className="border-t border-white/10 py-24 lg:py-40">
      <div className="wrap">
        <SectionHead label={t.approach.label} title={t.approach.title} />
        <ol className="mt-16 grid grid-cols-1 gap-px border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-4">
          {t.approach.steps.map((s, i) => (
            <Reveal as="li" key={s.title} delay={i * 0.08} data-testid={`approach-step-${i + 1}`} className="group relative flex min-h-[300px] flex-col bg-ink p-8 transition-colors duration-500 hover:bg-ink-2 lg:p-10">
              <motion.span
                aria-hidden
                className="absolute left-0 top-0 h-[2px] w-full origin-left bg-signal"
                initial={{ scaleX: 0 }}
                whileInView={{ scaleX: 1 }}
                viewport={{ once: true, amount: 0.15 }}
                transition={{ duration: 1.2, delay: 0.3 + i * 0.2, ease: EASE }}
              />
              <span className="stroke-text font-display text-7xl font-semibold leading-none transition-colors duration-500 group-hover:text-signal">0{i + 1}</span>
              <h3 className="mt-auto pt-12 font-display text-2xl font-semibold tracking-tight">{s.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-zinc-400">{s.desc}</p>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
};
